import YFormCouponCodePieChart from './CouponCodePieChart';

export { YFormCouponCodePieChart };
export default YFormCouponCodePieChart;
